import { PdpSharedShippingHolidayDelivery_item as Item } from '../__generated__/PdpSharedShippingHolidayDelivery_item.graphql';
import { PdpSharedShippingHolidayDelivery_viewer as Viewer } from '../__generated__/PdpSharedShippingHolidayDelivery_viewer.graphql';

type Today = {
    day: number;
    month: number;
    year: number;
};

const getToday = (): Today => {
    const today = new Date();
    return {
        day: today.getDate(),
        month: today.getMonth(),
        year: today.getFullYear(),
    };
};

type ShipmentDeliveryEstimations = Item['shipmentDeliveryEstimations'];
type ShipmentEstimationMap = {
    [shipmentQuoteId: string]:
        | {
              maxDaysToDeliver: number;
          }
        | undefined;
};

const getShipmentEstimationMap = (
    shipmentDeliveryEstimations: ShipmentDeliveryEstimations
): ShipmentEstimationMap => {
    return (shipmentDeliveryEstimations || []).reduce((acc: ShipmentEstimationMap, estimation) => {
        const { maxDaysToDeliver = null, shipmentQuoteId } = estimation || {};
        if (shipmentQuoteId && maxDaysToDeliver !== null) {
            acc[shipmentQuoteId] = { maxDaysToDeliver };
        }
        return acc;
    }, {});
};

type RelevantShipping = NonNullable<Viewer['relevantShipping']>;
type ShipmentQuotes = NonNullable<RelevantShipping['shipmentQuotes']>;

type ShipmentQuote = NonNullable<ShipmentQuotes[0]>;

type HolidayShippingInfoArgs = {
    shipmentQuotes: ShipmentQuotes;
    shipmentDeliveryEstimations: ShipmentDeliveryEstimations;
};
type EstimatedDeliveryData = {
    estimatedDeliveryDate: Date;
};
type HolidayShippingInfo = (ShipmentQuote & EstimatedDeliveryData)[];

export const getHolidayShippingInfo = ({
    shipmentQuotes,
    shipmentDeliveryEstimations,
}: HolidayShippingInfoArgs): HolidayShippingInfo => {
    const holidayDeadline = new Date(new Date().getFullYear(), 11, 23);
    const { month, day, year } = getToday();
    const shipmentEstimationMap = getShipmentEstimationMap(shipmentDeliveryEstimations);

    return (shipmentQuotes || []).reduce((acc: HolidayShippingInfo, shipmentQuote) => {
        const { serviceId } = shipmentQuote || {};
        const shipmentEstimation = serviceId && shipmentEstimationMap[serviceId];
        const maxDaysToDeliver = shipmentEstimation ? shipmentEstimation.maxDaysToDeliver : null;
        const estimatedDeliveryDate = new Date(year, month, day + (maxDaysToDeliver || 0));
        if (
            shipmentQuote &&
            maxDaysToDeliver !== null &&
            estimatedDeliveryDate.getTime() <= holidayDeadline.getTime()
        ) {
            acc.push({
                ...shipmentQuote,
                estimatedDeliveryDate,
            });
        }
        return acc;
    }, []);
};
